export const VERIFY_TOKEN_STARTED = 'VERIFY_TOKEN_STARTED';
export const VERIFY_TOKEN_END = 'VERIFY_TOKEN_END';

export const USER_LOGIN_STARTED = 'USER_LOGIN_STARTED';
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';

export const VERIFY_USER_SUCCESS = 'VERIFY_USER_SUCCESS';
export const USER_LOGOUT = 'USER_LOGOUT';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_CHILD_USER = 'UPDATE_CHILD_USER';
export const UPDATE_LAST_VISITED_ROUTE = 'UPDATE_LAST_VISITED_ROUTE';

export const REGISTERORG = "REGISTERORG";
export const REGISTERORGUSER = 'REGISTERORGUSER';
export const REGISTERSUBSCRIBER = 'REGISTERSUBSCRIBER';
export const REGISTERFACULTY = 'REGISTERFACULTY';
export const REGISTERPARENT = 'REGISTERPARENT';
export const REGISTERMINOR = 'REGISTERMINOR';
export const REGISTERSTUDENT = 'REGISTERSTUDENT';
export const RESETREGISTERORG = 'RESETREGISTERORG';
export const REGISTERAVATAR = "REGISTERAVATAR";
export const INVITEPARENT = "INVITEPARENT";

export const SAVEORGSUCCESS = 'SAVEORGSUCCESS';
export const SAVEPARENTSUCCESS = 'SAVEPARENTSUCCESS';
export const RESETSTOREREGISTER = 'RESETSTOREREGISTER';

export const REMOVE_CHILD = 'REMOVE_CHILD';
export const UPDATE_SCHOOL = 'UPDATE_SCHOOL';
export const CHANGE_SUPERADMIN_VIEW = 'CHANGE_SUPERADMIN_VIEW';

export const UPDATE_STUDENT_USER = "UPDATE_STUDENT_USER";
